import { isDefined } from "@/utils/utils";
import { t } from "i18next";
import { formatLocaleCurrency } from "../../../../../common/utils/formatUtils";
import { formatCommissionsLevelName } from "../../../../commissions/level/utils";
import { DashboardGoalType } from "../../../enums";
import { DashboardGoal, UpdateDashboardGoal } from "../../../types";

export const getGoalTargetValueName = (goalType?: DashboardGoalType) => {
  switch (goalType) {
    case DashboardGoalType.BROKER_LEVEL:
      return "targetCommissionsLevelId";
    case DashboardGoalType.BROKER_RANK:
      return "targetCommissionsRankId";
    case DashboardGoalType.TIPPER_BASIC_ACADEMY:
    case DashboardGoalType.TIPPER_STATUS:
      return "targetDate";
    default:
      return "targetValue";
  }
};

export const BROKER_FIXED_GOALS = [
  DashboardGoalType.BROKER_POINTS,
  DashboardGoalType.BROKER_ALL_TRAINEES,
  DashboardGoalType.BROKER_CLIENTS,
  DashboardGoalType.BROKER_AGENTS,
];

export const TIPPER_FIXED_GOALS = [
  DashboardGoalType.TIPPER_POINTS,
  DashboardGoalType.TIPPER_DIRECT_TRAINEES,
  DashboardGoalType.TIPPER_COMMISSIONS,
];

export const isCreatedGoal = (
  goal?: DashboardGoal,
): goal is DashboardGoal & { id: string; optimisticLockVersion: string } => !!goal?.id;

export const convertDashboardGoalToUpdateObject = (
  goal: DashboardGoal & { id: string; optimisticLockVersion: string },
): UpdateDashboardGoal & Pick<DashboardGoal, "year" | "type"> => {
  const {
    id,
    createdAt,
    updatedAt,
    actualValue,
    dateGoalReached,
    actualCommissionsRank,
    actualCommissionsLevel,
    targetCommissionsLevel,
    targetCommissionsRank,
    ...data
  } = goal;

  return {
    ...data,
    targetCommissionsLevelId: targetCommissionsLevel?.id,
    targetCommissionsRankId: targetCommissionsRank?.id,
  };
};

export const getGoalActualValue = (goal: DashboardGoal) => {
  if (goal.actualCommissionsRank) {
    return `${t("dashboard.goals.helpers.currentRank")}: ${goal.actualCommissionsRank.name}`;
  } else if (goal.actualCommissionsLevel) {
    return `${t("dashboard.goals.helpers.currentLevel")}: ${formatCommissionsLevelName(goal.actualCommissionsLevel)}`;
  } else if (isDefined(goal.actualValue)) {
    return `${t("dashboard.goals.helpers.currentValue")}: ${goal.type === DashboardGoalType.BROKER_COMMISSIONS || goal.type === DashboardGoalType.TIPPER_COMMISSIONS ? formatLocaleCurrency(goal.actualValue, 0) : goal.actualValue}`;
  }

  return "";
};
